import { Form, Formik } from "formik"
import React from "react"
import { useTranslation } from "react-i18next"

import { Button } from "~/components/Button/Button"
import { FormCheckbox } from "~/components/Checkbox/Checkbox"
import { Heading } from "~/components/Heading/Heading"
import { Raw } from "~/components/raw"

import styles from "./index.module.css"

type Props = {
  categoriesList: { id: string; code: string; name: string }[]
  returnValuesType: "id" | "code" | "name"
  state: string[]
  onSubmit: (v: string[]) => void
  closeHandler: () => void
}

export const Content: React.FC<Props> = ({
  categoriesList,
  returnValuesType,
  state,
  onSubmit,
  closeHandler,
}) => {
  const { t } = useTranslation()

  const submitHandler = (v: { categories: string[] }): void => {
    onSubmit(v.categories)
    closeHandler()
  }

  return (
    <>
      <Heading className={styles.Title} like="h3">
        <Raw html={t("PopupCategories.Content.Title")} />
      </Heading>

      <Formik initialValues={{ categories: state }} onSubmit={submitHandler}>
        {() => (
          <Form>
            {categoriesList.map(({ id, code, name }) => {
              const values = {
                id: id,
                code: code,
                name: name,
              }

              return (
                <FormCheckbox
                  key={id}
                  label={name}
                  name="categories"
                  value={values[returnValuesType]}
                />
              )
            })}

            <div className={styles.ButtonWrapper}>
              <Button type="submit" view="xl">
                <Raw html={t("PopupCategories.Content.Button")} />
              </Button>
            </div>
          </Form>
        )}
      </Formik>
    </>
  )
}
